import React from "react";
import { Box, Typography } from "@mui/material";

interface PanelGroupProps {
  title: string;
  children: React.ReactNode;
}

/**
 * A bordered, titled group of panel content.
 */
const PanelGroup: React.FC<PanelGroupProps> = ({ title, children }: PanelGroupProps) => (
  <Box border={1} borderColor="action.focus" borderRadius={1} px={1} py={0.75} sx={{ mb: 1, "&:last-child": { mb: 0 } }}>
    <Typography fontWeight="500" mb={0.5}>
      {title}
    </Typography>
    {children}
  </Box>
);

export default PanelGroup;
